export const defaults = {
  submitted: 'Submitted',
  VisitAttributes: 'VISIT ATTRIBUTES',
  F2F: 'FACE TO FACE',
  forms: 'FORMS',
  patientMeasures: 'MEASURES TAKEN',
  patientProgressNotes: 'PROGRESS NOTES',
  hcpcs: 'HCPCS',
  travelTime: 'Travel Time',
  travelTimeInProgress: 'In Progress',
  duration: 'Duration',
  visitType: 'Visit type',
  visitDetails: 'Face to face visit details on',
  provider: 'Provider',
  faceToFace: 'Face To Face',
  patientTasks: 'TASKS COMPLETED',
  documentationTime: 'DOCUMENTATION TIME',
  loading: 'Loading...',
  editEnd: 'End',
  editStart: 'Start',
  editCC: 'CC Duration:',
  editTime: 'Duration:'
};